import { render, staticRenderFns } from "./BalanceSuccess.vue?vue&type=template&id=d5b5113c&scoped=true"
import script from "./BalanceSuccess.vue?vue&type=script&lang=js"
export * from "./BalanceSuccess.vue?vue&type=script&lang=js"
import style0 from "./BalanceSuccess.vue?vue&type=style&index=0&id=d5b5113c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b5113c",
  null
  
)

export default component.exports